export const SelfPartnerTypeId = 0;
